import { Types } from '@wheeebo/polaris-api';
const DRONE_TERMS = {
    executeNow: 'Execute now',
    executing: 'Executing',
    pause: 'Pause',
    paused: 'Paused',
    resume: 'Resume',
    abort: 'Abort',
    completed: 'Completed',
    incompleted: 'Incompleted',
    executeDialogTitle: 'Confirm',
    executeDialogDescription: 'Are you really going to execute this flight plan right now?',
    holdPosition: 'Hold position',
    holdPositionHelp: 'Hold the current position (Loiter/PosHold).',
};
const ASV_TERMS = {
    executeNow: '出航 Depart',
    executing: '航行中 Underway',
    pause: '減速停船 Hold',
    paused: '停船中 Holding',
    resume: '再開 Resume',
    abort: '中止 Abort',
    completed: '完了 Completed',
    incompleted: '未完 Incomplete',
    executeDialogTitle: '出航前チェック Pre-departure checks',
    executeDialogDescription: 'Check that the vehicle is ready to depart, then start the mission. ' +
        'While paused the boat holds its position (station keeping) instead of drifting.',
    holdPosition: '定位置保持 Station keeping',
    holdPositionHelp: 'Hold the current position against wind and current (marine "hover").',
};
export function isAsv(vehicleType) {
    return vehicleType === Types.VehicleTypeAsv;
}
export function vehicleActionTerms(vehicleType) {
    return isAsv(vehicleType) ? ASV_TERMS : DRONE_TERMS;
}
export const WAYPOINT_TERMINOLOGY_KEY = 'wheeebo.waypointTerminology';
export function getWaypointTerminology() {
    try {
        return localStorage.getItem(WAYPOINT_TERMINOLOGY_KEY) === 'drone' ? 'drone' : 'marine';
    }
    catch {
        return 'marine';
    }
}
export function setWaypointTerminology(mode) {
    try {
        localStorage.setItem(WAYPOINT_TERMINOLOGY_KEY, mode);
    }
    catch {
        // Storage unavailable (private mode) — session-only state still works.
    }
}
export function waypointFieldVisibility(action, mode) {
    const a = action || '';
    if (mode === 'marine') {
        return { altitude: false, yaw: false, duration: a === 'STAY', speed: !!a && a !== 'TAKE_OFF' };
    }
    return {
        altitude: a === 'STAY' || a === 'MOVE_TO',
        yaw: false,
        duration: a === 'STAY',
        speed: !!a && a !== 'TAKE_OFF',
    };
}
export function waypointFieldLabels(mode) {
    if (mode === 'marine') {
        return { altitude: 'Altitude', yaw: 'Heading', duration: 'Hold time', speed: 'Speed' };
    }
    return { altitude: 'Altitude', yaw: 'Yaw', duration: 'Duration', speed: 'Speed to location' };
}
const MARINE_ACTION_LABELS = {
    TAKE_OFF: '出航 Depart',
    MOVE_TO: '移動 Move',
    STAY: '定位置保持 Keep',
    LAND: '帰港 Return',
};
/**
 * Waypoint action labels. The underlying enum values are shared with
 * the drone data model — for ASV missions they map onto marine
 * semantics (depart point, move, station keep, return-to-port).
 * Without `terminology` the bilingual combined label is returned.
 */
export function waypointActionLabel(action, terminology) {
    if (!action) {
        return '';
    }
    if (terminology === 'drone') {
        return action;
    }
    const marine = MARINE_ACTION_LABELS[action];
    if (!marine) {
        return action;
    }
    return terminology === 'marine' ? marine : `${action} · ${marine}`;
}
